import { Action as BaseReduxAction } from 'redux';

export interface ReduxAction<A extends Action> extends BaseReduxAction {
    type: string;
    payload: A;
}

export abstract class Action implements BaseReduxAction {
    readonly type: string;
    constructor(type?: string) {
        this.type = type || this.constructor.name;
    }
    makeReduxAction(): ReduxAction<this> {
        return {
            type: this.type,
            payload: this
        };
    }
}

// Describes a class inherited from the abstract Action class.
export interface ActionClass<A extends Action> {
    new (...args: any[]): A;
}

export function actionMatches<A extends Action>(
        actionDescriptor: ActionClass<A> | string,
        action: BaseReduxAction): boolean {
    const actionName: string = typeof(actionDescriptor) === 'string' ? actionDescriptor : actionDescriptor.name;
    return action.type === actionName || action.type.startsWith(actionName + '.');
}
